export default `
  mutation downgradeSubscriptionQuantity {
    downgradeSubscriptionQuantity {
      success
      message
    }
  }
`
